<template>
  <div>
    <!-- <el-table @cell-mouse-enter="rowHover" @cell-mouse-leave="rowHoverLeave" -->
    <el-table 
              @row-click="''"
              id="payoutsTable" class="table-striped" 
              :data="data" :row-class-name="rowClasses">
      
      
      <el-table-column width="120" label="Date">
        <template slot-scope="{row}">
          <template v-if="row">
            {{displayDate(row.dateCreated)}}
          </template>
        </template>
      </el-table-column>

      <el-table-column width="130" v-if="$store.getters.companySelected == 0" label="Company">
        <template slot-scope="{row}">
          <template v-if="row">
            {{ $store.getters.getIncentifyerName(row.incentifyerAccountId) }}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column width="85" label="Amount">
        <template slot-scope="{row}">
          <template v-if="row">
            <div :id="'amountDiv'+row.id" class="toShowWhenClosing">
              <span :id="'amountValue'+row.id">
                {{ $store.getters.currency + row.amount }}
              </span>
            </div>
          </template>
        </template> 
      </el-table-column>
      
      <el-table-column width="85" label="Status">
        <template slot-scope="{row}">
          <template v-if="row">
            {{Object.values($store.getters.Payout._status).find(s => s.value == row.status)
              ? Object.values($store.getters.Payout._status).find(s => s.value == row.status).label
              : ''}}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column width="120" label="Reason">
        <template slot-scope="{row}">
          <template v-if="row">
            {{Object.values($store.getters.Payout._type).find(t => t.value == row.type)
              ? Object.values($store.getters.Payout._type).find(t => t.value == row.type).label
              : ''}}
          </template>
        </template>
      </el-table-column>
      
      <el-table-column label="Details">
        <template slot-scope="{row}">
          <template v-if="row">
            <template v-if="row.leadId">
              {{$store.getters.leadsJson[row.leadId] ? $store.getters.leadsJson[row.leadId].name : '-'}}
            </template>
            <template v-else>
              <div :id="'noteDiv'+row.id" class="toShowWhenClosing">
                <span :id="'noteValue'+row.id">
                  {{row.note}}
                </span>
                <a v-if="row.status == $store.getters.Payout._status.PENDING.value" class="btn-info text-primary btn-link d-none showOnHover mr-1" v-tooltip.top-center="'Edit note'"
                  @click="editNote(row.id)">
                  <i class="fas fa-pencil-alt"></i>
                </a>
              </div>
              <div :id="'noteEditDiv'+row.id" class="d-none toHideWhenClosing">
                <input :id="'noteInput'+row.id" type="text"/>
                <a class="btn-info btn-link text-success" @click="saveEditNote(row)" v-tooltip.top-center="'Save'"> <i class="ml-1 fas fa-check"/> </a>
                <a class="btn-info btn-link text-danger" @click="cancelEditNote(row.id)" v-tooltip.top-center="'Cancel'"> <i class="ml-1 fas fa-times"/> </a>
              </div>
            </template>
          </template>
        </template>
      </el-table-column>


      <el-table-column v-if="selectObjects" width="30">
        <template slot-scope="{row}">
          <!-- <a class="btn-info btn-link"> <i class="far fa-square"/></a> -->
          <div>
            <l-checkbox v-show="rowSelectable(row)" :id="'selectpayout'+row.id" @change="selectRow(row)"/>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="1">
        <template slot-scope="{row}">
          <div :payoutid="row.id"/>
        </template>
      </el-table-column>

    </el-table>
  </div>  
</template>

<script>
import {Affiliate, Payout, Lead} from 'src/classes/datamodel.js'
import utils from '../../utils'
export default {
    name: 'Payouts-Table',
    props: {
      //forCompany:     {type: Object, default: null},
      hideAddPayout:  {type: Boolean, default: false}
    },
    computed: {
      data () {
        return this.$store.getters.payouts
      },
      selectObjects () {
        // return false if a modal is currently open
        return !this.$store.getters.modal.current && this.$store.getters.selectedObjects
      }
    }, 
    methods: {
      displayDate (date) {
        return utils.dateToString(date)
      },
      rowClasses ({row, rowIndex}) {
        return row.archived ?'archivedTableRow' : ''
      },
      // rowHover(row, column, cell, event) {
      //   // We show all buttons of class .showOnHover
      //   var rows = $('#payoutsTable > div > table > tbody > tr')
      //   for (var i = 0; i < rows.length; i++) {
      //     var foundRow = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"')) > -1
      //     var archivedRow = $(rows[i]).attr('class').indexOf('archivedTableRow') > -1
      //     if (foundRow && !archivedRow) {
      //       var icons = $(rows[i]).find('.showOnHover')
      //       for (var j = 0; j < icons.length; j++) {
      //         $(icons[j]).removeClass('d-none')
      //       }
      //       break
      //     }
      //   }
      // },
      // rowHoverLeave (row, column, cell, event) {
      //   // We hide all buttons of class .showOnHover
      //   var rows = $('#payoutsTable > div > table > tbody > tr')
      //   for (var i = 0; i < rows.length; i++) {
      //     var index = JSON.stringify($(rows[i]).html().indexOf('payoutid="'+row.id+'"'))
      //     if (index > -1) {
      //       var icons = $(rows[i]).find('.showOnHover')
      //       for (var j = 0; j < icons.length; j++) {
      //         $(icons[j]).addClass('d-none')
      //       }
      //       break
      //     }
      //   }
      // },
      // This method is called when clicking a checkbox to select a row
      // It's going to update the ObjectsWithId in the state (selectedObjects.objectsJson)
      selectRow (row) {
        this.$store.commit('SELECT_OBJECT', row)
      },
      rowSelectable(row) {
        if (this.$store.getters.selectedObjectsJson) { // if selection mode is active
          let filter = this.$store.getters.selectedObjectsFilter
          let filterKeys = filter ? Object.keys(filter) : []
          let match = true
          filterKeys.forEach(key => {
            if (row[key] != filter[key]) {
              match = false
            }
          });
          return match
        }
        return false
      }
    }
}
</script>

<style>
.el-table__row .cell {
  padding: 0;
}
.has-gutter .is-leaf .cell {
  padding: 0;
}
</style>